module.exports = __webpack_public_path__ + "media/73.58016c2a.mp3";